export default __webpack_public_path__ + "static/media/normalCircle.50a6e365.svg";